/**
 * Util to wait specific timeout which returns promise
 */
export default async function wait(delay, value) {
  return new Promise(resolve => setTimeout(resolve, delay, value)).catch(reason => {
    window?.newrelic?.noticeError(reason);
  });
}
